import { Play, Volume2, Maximize2 } from "lucide-react";

/**
 * Decorative video-player chrome layered over a still image so the media
 * reads as a paused video (matches 47skin's PDP treatment).
 * Purely visual — no playback wiring. Position: absolute, needs a relative parent.
 *
 * @param {string} time - Timecode label (e.g. "0:00 / 0:12"). Optional.
 * @param {number} progress - Progress bar fill 0..1 (default 0).
 */
export const PlayerChrome = ({ time = "0:00 / 0:12", progress = 0 }) => (
  <div className="absolute inset-x-0 bottom-0 p-3 md:p-4 pointer-events-none">
    {/* Subtle gradient scrim so controls read on any image */}
    <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/45 to-transparent" />
    {/* Progress bar */}
    <div className="relative h-[3px] bg-white/25 overflow-hidden mb-2 md:mb-3">
      <div
        className="h-full bg-white/85"
        style={{ width: `${Math.max(0, Math.min(1, progress)) * 100}%` }}
      />
    </div>
    {/* Controls row */}
    <div className="relative flex items-center justify-between text-white/90">
      <div className="flex items-center gap-3">
        <span
          className="flex items-center justify-center w-6 h-6 rounded-full bg-white/15 backdrop-blur"
          aria-hidden="true"
        >
          <Play size={11} strokeWidth={2.5} fill="currentColor" className="ml-[1px]" />
        </span>
        <span className="font-mono text-[11px] tracking-wide tabular-nums">{time}</span>
      </div>
      <div className="flex items-center gap-3">
        <Volume2 size={14} strokeWidth={1.75} />
        <Maximize2 size={13} strokeWidth={1.75} />
      </div>
    </div>
  </div>
);

export default PlayerChrome;
